/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PhysicianSubscriberCount } from './PhysicianSubscriberCount';
import {
    PhysicianSubscriberCountFromJSON,
    PhysicianSubscriberCountFromJSONTyped,
    PhysicianSubscriberCountToJSON,
} from './PhysicianSubscriberCount';

/**
 * The most recent daily census of active subscribers by primary practitioner.
 * @export
 * @interface SubscriberCountSnapshot
 */
export interface SubscriberCountSnapshot {
    /**
     * When the snapshot was taken (Unix seconds).
     * @type {number}
     * @memberof SubscriberCountSnapshot
     */
    date?: number;
    /**
     * Active subscribers with no primary practitioner on file.
     * @type {number}
     * @memberof SubscriberCountSnapshot
     */
    unassigned?: number;
    /**
     * 
     * @type {Array<PhysicianSubscriberCount>}
     * @memberof SubscriberCountSnapshot
     */
    physicians?: Array<PhysicianSubscriberCount>;
}

/**
 * Check if a given object implements the SubscriberCountSnapshot interface.
 */
export function instanceOfSubscriberCountSnapshot(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SubscriberCountSnapshotFromJSON(json: any): SubscriberCountSnapshot {
    return SubscriberCountSnapshotFromJSONTyped(json, false);
}

export function SubscriberCountSnapshotFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriberCountSnapshot {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': !exists(json, 'date') ? undefined : json['date'],
        'unassigned': !exists(json, 'unassigned') ? undefined : json['unassigned'],
        'physicians': !exists(json, 'physicians') ? undefined : ((json['physicians'] as Array<any>).map(PhysicianSubscriberCountFromJSON)),
    };
}

export function SubscriberCountSnapshotToJSON(value?: SubscriberCountSnapshot | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date,
        'unassigned': value.unassigned,
        'physicians': value.physicians === undefined ? undefined : ((value.physicians as Array<any>).map(PhysicianSubscriberCountToJSON)),
    };
}

